var React = require('react');

function CollapsibleChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"tree-closed","d":"M11.94,6L10.06,7.88L18.167,16L10.06,24.12L11.94,26L21.94,16L11.94,6Z","style":{"fillRule":"nonzero"}}));
}

CollapsibleChevron.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 32 32","version":"1.1","xmlSpace":"preserve","xmlnsSerif":"http://www.serif.com/","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = CollapsibleChevron;

CollapsibleChevron.default = CollapsibleChevron;
